export const checkIfPasswordIsValid = (password: string): boolean => {
	return password.length >= 8;
};
